import { Observable } from 'rxjs/Observable';
import { errorHelper } from '../../../actions';
import { Config } from '../../../config';
import {
    RESET_PASSWORD_SAID_SUBMIT,
    RESET_PASSWORD_SAID_CAPTURE,
    RESET_PASSWORD_SAID_ERROR,
    RESET_PASSWORD_SAID_RESET_STATE,
} from '../../../actions/types';
import { getUuid } from '../../../utils/utils';

export const searchSaId = (args, callback) => ({
    type: RESET_PASSWORD_SAID_SUBMIT,
    payload: { args, callback },
});

export const searchSaIdEpic = action$ =>
    action$.ofType(RESET_PASSWORD_SAID_SUBMIT).mergeMap(action =>
        Observable.ajax({
            url: `${Config.rootUrl}/${Config.apiContext.reset}/${Config.apiVersion}${Config.apiUri.searchId}`,
            method: 'POST',
            crossDomain: true,
            headers: {
                ...Config.headers,
                Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
                'Correlation-Id': getUuid(),
            },
            body: {
                saId: action.payload.args.said,
            },
        })
            .map(response => {
                action.payload.callback(response);

                return {
                    type: RESET_PASSWORD_SAID_CAPTURE,
                    payload: response,
                };
            })
            .catch(({ xhr }) => {
                action.payload.callback(xhr);

                return Observable.of(errorHelper(RESET_PASSWORD_SAID_ERROR, xhr));
            }),
    );

export const resetState = () => ({ type: RESET_PASSWORD_SAID_RESET_STATE });
